module.exports = __webpack_public_path__ + "cy.59aa3a04.svg";